import type { MutableRefObject } from 'react'
import { useEffect, useRef } from 'react'

export const useFreshComponentRef = <T>(initialValue: T) => {
  const ref = useRef(initialValue)

  useEffect(() => {
    ref.current = initialValue
  }, [initialValue])

  return ref as MutableRefObject<T>
}
